/*
 *
 * DataRow
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 14-Oct-2024
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import DataRow from './DataRow'

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DataRow)
